import { Component } from '@angular/core';
import * as fromRoot from '@app/reducer';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'pcs-global-loader',
  templateUrl: './global-loader.component.html',
  styleUrls: ['./global-loader.component.scss']
})
export class GlobalLoaderComponent {
  isLoading$: Observable<boolean>;

  constructor(private store: Store<fromRoot.State>) {
    this.isLoading$ = this.store.pipe(select(fromRoot.getIsLoading));
  }

}
